import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "col q-pb-sm" }
const _hoisted_3 = { class: "col q-pb-sm" }
const _hoisted_4 = { class: "q-pa-sm" }
const _hoisted_5 = { class: "q-pa-sm" }
const _hoisted_6 = { class: "q-pa-sm" }
const _hoisted_7 = { class: "q-pa-sm" }
const _hoisted_8 = { class: "q-pa-sm" }
const _hoisted_9 = { class: "q-pa-sm" }
const _hoisted_10 = { class: "q-pa-sm" }
const _hoisted_11 = {
  key: 0,
  class: "q-pa-sm"
}
const _hoisted_12 = { class: "q-pb-sm" }
const _hoisted_13 = { class: "q-pa-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col q-pb-sm text-grey-brand text-bold" }, " User Notifications ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_btn, {
          dense: "",
          size: "sm",
          class: "btn-brand",
          icon: "fas fa-plus",
          label: "Add User Notification",
          "no-caps": "",
          onClick: _ctx.onAddUserNotification
        }, null, 8, ["onClick"]),
        _cache[15] || (_cache[15] = _createTextVNode("  ", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_table, {
          pagination: _ctx.infinitePagination,
          "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.infinitePagination) = $event)),
          dense: "",
          flat: "",
          title: "",
          rows: _ctx.notificationTable,
          columns: _ctx.userNotificationColumns,
          "row-key": "userId",
          "no-data-label": "No user notifications added",
          "hide-pagination": "",
          "visible-columns": _ctx.userNotificationVisibleColumns
        }, {
          "body-cell-info-user": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  size: "xs",
                  dense: "",
                  icon: "fas fa-info-circle",
                  onClick: ($event: any) => (_ctx.onUserNotificationInfo(props))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-delete-user": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  size: "xs",
                  dense: "",
                  icon: "fas fa-trash",
                  onClick: ($event: any) => (_ctx.onDeleteUserNotification(props))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["pagination", "rows", "columns", "visible-columns"])
      ])
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.infoNotifierDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.infoNotifierDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "User Notification", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            (_ctx.selectedUserNotification)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, "User: " + _toDisplayString(_ctx.selectedUserNotification.name), 1),
                    _createElementVNode("div", _hoisted_5, " Launch: " + _toDisplayString(_ctx.selectedUserNotification.launch), 1),
                    _createElementVNode("div", _hoisted_6, " Receive: " + _toDisplayString(_ctx.selectedUserNotification.receive), 1),
                    _createElementVNode("div", _hoisted_7, " Medium: " + _toDisplayString(_ctx.selectedUserNotification.medium), 1),
                    _createElementVNode("div", _hoisted_8, " Passage Type: " + _toDisplayString(_ctx.selectedUserNotification.passageType), 1),
                    _createElementVNode("div", _hoisted_9, " Include Manual: " + _toDisplayString(_ctx.selectedUserNotification.manualPassage), 1),
                    _createElementVNode("div", _hoisted_10, " All Markers: " + _toDisplayString(_ctx.selectedUserNotification.allMarkers), 1),
                    (!_ctx.selectedUserNotification.allMarkers)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Markers: " + _toDisplayString(_ctx.selectedUserNotification.markers), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Close",
                          "no-caps": ""
                        }, null, 512), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addNotifierDialog,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addNotifierDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Add User Notification", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.selectedUser,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUser) = $event)),
                    dense: "",
                    options: _ctx.userOptions,
                    color: "blue-brand",
                    label: "User",
                    filled: ""
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "q-mb-md" }, "Notification Settings", -1)),
                  _createVNode(_component_q_card, {
                    flat: "",
                    bordered: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.medium,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.medium) = $event)),
                        color: "blue-brand",
                        val: "sms",
                        label: "SMS"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.medium,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.medium) = $event)),
                        color: "blue-brand",
                        val: "email",
                        label: "E-mail"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.medium,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.medium) = $event)),
                        color: "blue-brand",
                        val: "both",
                        label: "Both"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.medium,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.medium) = $event)),
                        color: "blue-brand",
                        val: "none",
                        label: "None"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card, {
                    flat: "",
                    bordered: "",
                    class: "q-mt-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, {
                        modelValue: _ctx.launch,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.launch) = $event)),
                        color: "blue-brand",
                        label: "At Launch"
                      }, null, 8, ["modelValue"]),
                      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_q_checkbox, {
                        modelValue: _ctx.receive,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receive) = $event)),
                        color: "blue-brand",
                        label: "At Receive"
                      }, null, 8, ["modelValue"]),
                      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card, {
                    flat: "",
                    bordered: "",
                    class: "q-mt-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.passageType,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.passageType) = $event)),
                        color: "blue-brand",
                        val: "verified",
                        label: "Verified Passages"
                      }, null, 8, ["modelValue"]),
                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.passageType,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.passageType) = $event)),
                        color: "blue-brand",
                        val: "passage",
                        label: "All Passages (excluding manual)"
                      }, null, 8, ["modelValue"]),
                      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_q_checkbox, {
                        modelValue: _ctx.manualPassages,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.manualPassages) = $event)),
                        color: "blue-brand",
                        label: "Include Manual Passages"
                      }, null, 8, ["modelValue"]),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card, {
                    flat: "",
                    bordered: "",
                    class: "q-mt-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, {
                        modelValue: _ctx.allMarkers,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.allMarkers) = $event)),
                        color: "blue-brand",
                        label: "All Markers"
                      }, null, 8, ["modelValue"]),
                      (!_ctx.allMarkers)
                        ? (_openBlock(), _createBlock(_component_q_select, {
                            key: 0,
                            modelValue: _ctx.tmpSelectedMarkers,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tmpSelectedMarkers) = $event)),
                            dense: "",
                            filled: "",
                            color: "blue-brand",
                            multiple: "",
                            options: _ctx.markerOptions,
                            "use-chips": "",
                            "stack-label": "",
                            label: "Markers",
                            style: {"width":"300px"}
                          }, null, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Cancel",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      disable: _ctx.selectedUser == '',
                      class: "btn-brand",
                      label: "Save",
                      "no-caps": "",
                      onClick: _ctx.onUserNotificationAdded
                    }, null, 8, ["disable", "onClick"]), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}